import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * 화면 제목 줄.
 *
 * <p><b>버튼은 제목 줄에 둔다</b> — 화면이 좁아 깨지더라도 자리를 옮기지 않고 이름·CSS 로 고친다.
 * 자리가 화면마다 다르면 어디를 눌러야 할지 매번 다시 찾게 된다.
 */
export function PageHeader({
  title,
  subtitle,
  action,
  back = true,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  back?: boolean;
}) {
  const navigate = useNavigate();

  return (
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="flex min-w-0 items-start gap-2">
        {back && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="뒤로"
            className="-ml-1 shrink-0 rounded px-1.5 py-0.5 text-ui-lg leading-none"
            style={{ color: 'var(--text-muted)' }}
          >
            ‹
          </button>
        )}
        <div className="min-w-0">
          <h1 className="truncate text-ui-lg font-semibold">{title}</h1>
          {subtitle !== undefined && (
            <p className="truncate text-ui-2xs" style={{ color: 'var(--text-muted)' }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {action !== undefined && <div className="shrink-0">{action}</div>}
    </div>
  );
}
